import {Text} from "@mantine/core";
import {PropsWithChildren} from 'react';

export function PageDescriptionText(props: PropsWithChildren) {
    return (
        <Text style={{color: "light-dark(#414242, #5a767e)"}} fw={500}>
            {props.children}
        </Text>
    )
}